import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { NOT_SET_VALUE } from '../../../constant'
import { TITLE_TABLE } from '../../../savedPortfolios/portfoliosOverview/constant'
import { CustomTdAction } from './CustomTdAction'
import { CustomTdAlert } from './CustomTdAlert'
import { CustomTdTitle } from './CustomTdTitle'
import { CustomThTitle } from './CustomThTitle'

export const getSchemaTablePortfolios = (
  typeAlertPortfolio,
  isShowRenameOnly,
  setIsShowRenameOnly,
) => {
  return TITLE_TABLE.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        whiteSpace: 'nowrap',
      },
      tdStyle: {
        whiteSpace: 'nowrap',
      },
    }
    if (index === 0) {
      return {
        ...result,
        title: <CustomThTitle item={item.label} />,
        colId: item.key,
        thStyle: {
          textAlign: 'left',
        },
        tdStyle: {
          whiteSpace: 'normal',
          padding: 0,
          width: '75%',
        },
        render: (val, { rowId }) => {
          return (
            <CustomTdTitle
              item={val}
              rowId={rowId}
              colId={item.key}
              isRename={true}
              isShowRenameOnly={isShowRenameOnly}
              setIsShowRenameOnly={setIsShowRenameOnly}
            />
          )
        },
      }
    }
    if (index === 1) {
      return {
        ...result,
        thStyle: {
          whiteSpace: 'normal',
          display: 'flex',
          justifyContent: 'flex-end',
          textAlign: 'end',
        },
        tdStyle: {
          textAlign: 'right',
          width: '25%',
        },
      }
    }
    if (index === 2) {
      return {
        ...result,
        thStyle: {
          textAlign: 'left',
        },
        tdStyle: {
          marginRight: 'auto',
        },
        render: (val, { rowId }) => {
          const data = typeAlertPortfolio.find((item) => item.value === val)
          return (
            <CustomTdAlert
              data={data ? data : NOT_SET_VALUE}
              rowId={rowId}
              colId={item.key}
            />
          )
        },
      }
    }
    if (index === 3 || index === 4) {
      return {
        ...result,
        thStyle: {
          textAlign: 'center',
          whiteSpace: 'nowrap',
          textTransform: 'capitalize',
        },
        tdStyle: { textAlign: 'left', whiteSpace: 'nowrap' },
        sortable: true,
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale)
        },
      }
    }
    if (index === 5) {
      return {
        ...result,
        render: (val, { rowId, locale }) => {
          return <CustomTdAction rowId={rowId} />
        },
      }
    }
    return {
      ...result,
      render: (val, { locale }) => {
        return val
      },
    }
  })
}
